import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createPayment } from "api/payment.api";
import {
  invalidateDashboardSources,
  invalidatePaymentSide,
} from "lib/cacheInvalidation";

export const useCreatePayment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createPayment,
    onSuccess: () => {
      invalidatePaymentSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
